var _a;
import { __makeTemplateObject } from "tslib";
import { template } from '../helpers/utils';
import { imageFilters, transformTypes, API_VERSION, fileType, } from '../helpers/imageServiceConstants';
// transform templates
var fitTemplate = template(templateObject_1 || (templateObject_1 = __makeTemplateObject(["fit/w_", ",h_", ""], ["fit/w_", ",h_", ""])), 'width', 'height');
var fillTemplate = template(templateObject_2 || (templateObject_2 = __makeTemplateObject(["fill/w_", ",h_", ",al_", ""], ["fill/w_", ",h_", ",al_", ""])), 'width', 'height', 'alignment');
var fillFocalTemplate = template(templateObject_3 || (templateObject_3 = __makeTemplateObject(["fill/w_", ",h_", ",fp_", "_", ""], ["fill/w_", ",h_", ",fp_", "_", ""])), 'width', 'height', 'focalPointX', 'focalPointY');
var cropTemplate = template(templateObject_4 || (templateObject_4 = __makeTemplateObject(["crop/x_", ",y_", ",w_", ",h_", ""], ["crop/x_", ",y_", ",w_", ",h_", ""])), 'x', 'y', 'width', 'height');
// legacy templates
var legacyCropTemplate = template(templateObject_5 || (templateObject_5 = __makeTemplateObject(["crop/w_", ",h_", ",al_", ""], ["crop/w_", ",h_", ",al_", ""])), 'width', 'height', 'alignment');
var legacyFillTemplate = template(templateObject_6 || (templateObject_6 = __makeTemplateObject(["fill/w_", ",h_", ",al_", ""], ["fill/w_", ",h_", ",al_", ""])), 'width', 'height', 'alignment');
// upscale template
var upscaleTemplate = template(templateObject_7 || (templateObject_7 = __makeTemplateObject([",lg_", ""], [",lg_", ""])), 'upscaleMethodValue');
// options templates
var qualityTemplate = template(templateObject_8 || (templateObject_8 = __makeTemplateObject([",q_", ""], [",q_", ""])), 'quality');
var unSharpMaskTemplate = template(templateObject_9 || (templateObject_9 = __makeTemplateObject([",usm_", "_", "_", ""], [",usm_", "_", "_", ""])), 'radius', 'amount', 'threshold');
var nonProgressiveTemplate = template(templateObject_10 || (templateObject_10 = __makeTemplateObject([",bl"], [",bl"])));
var watermarkTemplate = template(templateObject_11 || (templateObject_11 = __makeTemplateObject([",wm_", ""], [",wm_", ""])), 'watermark');
var filterTemplatesMap = (_a = {},
    _a[imageFilters.CONTRAST] = template(templateObject_12 || (templateObject_12 = __makeTemplateObject([",con_", ""], [",con_", ""])), 'contrast'),
    _a[imageFilters.BRIGHTNESS] = template(templateObject_13 || (templateObject_13 = __makeTemplateObject([",br_", ""], [",br_", ""])), 'brightness'),
    _a[imageFilters.SATURATION] = template(templateObject_14 || (templateObject_14 = __makeTemplateObject([",sat_", ""], [",sat_", ""])), 'saturation'),
    _a[imageFilters.HUE] = template(templateObject_15 || (templateObject_15 = __makeTemplateObject([",hue_", ""], [",hue_", ""])), 'hue'),
    _a[imageFilters.BLUR] = template(templateObject_16 || (templateObject_16 = __makeTemplateObject([",blur_", ""], [",blur_", ""])), 'blur'),
    _a);
var autoEncodeTemplate = template(templateObject_17 || (templateObject_17 = __makeTemplateObject([",enc_auto"], [",enc_auto"])));
/**
 * returns image transform uri
 * @param {object}  transformsObj
 *
 * @returns {string}
 */
function getImageURI(transformsObj) {
    // construct image transforms
    var transformsObjStrArr = [];
    // construct transform
    transformsObj.parts.forEach(function (transformPart) {
        switch (transformPart.transformType) {
            case transformTypes.CROP:
                transformsObjStrArr.push(cropTemplate(transformPart));
                break;
            case transformTypes.LEGACY_CROP:
                transformsObjStrArr.push(legacyCropTemplate(transformPart));
                break;
            case transformTypes.LEGACY_FILL:
                var legacyFillStr = legacyFillTemplate(transformPart);
                if (transformPart.upscale) {
                    legacyFillStr += upscaleTemplate(transformPart);
                }
                transformsObjStrArr.push(legacyFillStr);
                break;
            case transformTypes.FIT:
                var fitStr = fitTemplate(transformPart);
                if (transformPart.upscale) {
                    fitStr += upscaleTemplate(transformPart);
                }
                transformsObjStrArr.push(fitStr);
                break;
            case transformTypes.FILL:
                var fillStr = fillTemplate(transformPart);
                if (transformPart.upscale) {
                    fillStr += upscaleTemplate(transformPart);
                }
                transformsObjStrArr.push(fillStr);
                break;
            case transformTypes.FILL_FOCAL:
                var fillFocalStr = fillFocalTemplate(transformPart);
                if (transformPart.upscale) {
                    fillFocalStr += upscaleTemplate(transformPart);
                }
                transformsObjStrArr.push(fillFocalStr);
                break;
        }
    });
    var transformsStr = transformsObjStrArr.join('/');
    // construct transform options
    // quality
    if (transformsObj.quality) {
        transformsStr += qualityTemplate(transformsObj);
    }
    // un-sharp mask
    if (transformsObj.unsharpMask) {
        transformsStr += unSharpMaskTemplate(transformsObj.unsharpMask);
    }
    // progressive
    if (!transformsObj.progressive) {
        transformsStr += nonProgressiveTemplate(transformsObj);
    }
    // watermark
    if (transformsObj.watermark) {
        transformsStr += watermarkTemplate(transformsObj);
    }
    // filters
    if (transformsObj.filters) {
        transformsStr += Object.keys(transformsObj.filters)
            .map(function (filterName) {
            return filterTemplatesMap[filterName](transformsObj.filters);
        })
            .join('');
    }
    // auto encode
    if (transformsObj.autoEncode && transformsObj.fileType !== fileType.GIF) {
        transformsStr += autoEncodeTemplate(transformsObj);
    }
    // image url string
    return transformsObj.src.id + "/" + API_VERSION + "/" + transformsStr + "/" + transformsObj.fileName + "." + transformsObj.preferredExtension;
}
export { getImageURI };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;
//# sourceMappingURL=transforms.js.map